import { apiCall } from "@/api/client";

/** The closed vocabulary of a rule's class (`unknown` is what no rule matched: it is never a rule's class). */
export const RULE_CLASSES = [
  "robot",
  "smartphone",
  "feature_phone",
  "tablet",
  "desktop",
  "smart_speaker",
  "car",
  "console",
  "wearable",
  "tv",
  "portable_media_player",
  "physical_media_player",
  "camera",
] as const;
export type DeviceClass = (typeof RULE_CLASSES)[number];

export type ClassificationRule = { kind: "substring" | "regex"; value: string; class: DeviceClass; note?: string | null };
export type AudienceClassification = { version: number; rules: ClassificationRule[]; updatedAt: number; updatedBy: string };
/** A history row: the rules themselves stay server-side until a version is opened. */
export type AudienceClassificationVersion = { version: number; updatedAt: number; updatedBy: string; ruleCount: number };

const BASE = "/catalog/audience-classification";

export const getAudienceClassification = (token: string) => apiCall<AudienceClassification>(BASE, { token });

export const putAudienceClassification = (token: string, expectedVersion: number, rules: ClassificationRule[]) =>
  apiCall<AudienceClassification>(BASE, { token, method: "PUT", body: { expectedVersion, rules } });

export const getAudienceClassificationHistory = (token: string) =>
  apiCall<{ items: AudienceClassificationVersion[] }>(`${BASE}/history`, { token });

export const getAudienceClassificationVersion = (token: string, version: number) =>
  apiCall<AudienceClassification>(`${BASE}/history/${version}`, { token });
